import React from 'react';
import Marquee from 'react-fast-marquee';

const Clientes = () => {
  return (
    <Marquee className="Clientes">
      <img
        src="/static/images/logos-marquee/globant.svg"
        className="Logo"
      ></img>
      <img
        src="/static/images/logos-marquee/mercado-libre.svg"
        className="Logo"
      ></img>
      <img
        src="/static/images/logos-marquee/galicia.svg"
        className="Logo"
      ></img>
      <img src="/static/images/logos-marquee/ebay.svg" className="Logo"></img>
      <img
        src="/static/images/logos-marquee/verizon.svg"
        className="Logo"
      ></img>
      <img
        src="/static/images/logos-marquee/telecom.svg"
        className="Logo"
      ></img>
      <img src="/static/images/logos-marquee/sura.svg" className="Logo"></img>
      <img
        src="/static/images/logos-marquee/banamex.svg"
        className="Logo"
      ></img>
      <img
        src="/static/images/logos-marquee/exxon-mobil.svg"
        className="Logo"
      ></img>
      <img src="/static/images/logos-marquee/indra.svg" className="Logo"></img>
      <img src="/static/images/logos-marquee/mural.svg" className="Logo"></img>
      <img src="/static/images/logos-marquee/tec.svg" className="Logo"></img>
      <img
        src="/static/images/logos-marquee/vueling.svg"
        className="Logo"
      ></img>
    </Marquee>
  );
};

export default Clientes;
